import React, { memo } from 'react';
import { useParams } from 'react-router-dom';
import { AnsweredCustomersLayout } from '../../template/AnsweredCustomersLayout';
import { useFetchPaginateManLaboQuestionWithLineAccounts } from '../../../hooks/manzokudoLabo/useFetchPaginateManLaboQuestionWithLineAccounts';
import { Paginator } from '../../molecules/pagenation/Paginator';
import { Box, CardBody, CardFooter, CardHeader } from "@chakra-ui/react";
import { LightShadowCard } from '../../molecules/card/LightShadowCard';
import { CardHeading } from '../../molecules/card/CardHeading';
import { GiStarsStack } from 'react-icons/gi';
import { CircularLoading } from '../../molecules/loading/CircularLoading';


export const ManLaboSurveyQuestionAnsweredCustomers: React.FC = memo(() => {
  const { questionId } = useParams();
  const { manLaboQuestionWithLineAccountsPerPage, isLoading, pages, pagesCount, currentPage, setCurrentPage } = useFetchPaginateManLaboQuestionWithLineAccounts(questionId!)
  if (isLoading) return <CircularLoading />
  if (!manLaboQuestionWithLineAccountsPerPage) return null
  return (
    <Box m='auto' w='100%'>
      <LightShadowCard>
        <CardHeader>
          <CardHeading icon={<GiStarsStack size="20px" />} heading={manLaboQuestionWithLineAccountsPerPage.question}/>
        </CardHeader>
        <CardBody py={1}>
          <AnsweredCustomersLayout
            answerScores={manLaboQuestionWithLineAccountsPerPage.manzokudo_labo_survey_answer_score_with_line_accounts.map(score => ({
              id: score.id,
              line_account: score.line_account,
              score: score.answer_score,
              date: score.answered_at,
            }))}
          />
        </CardBody>
        <CardFooter>
          <Paginator pagesCount={pagesCount} currentPage={currentPage} setCurrentPage={setCurrentPage} pages={pages} />
        </CardFooter>
      </LightShadowCard>
    </Box>
    );
  });